import Routes from './Routes/Router'

function App() {
  return (
    <>
      <Routes/>
    </>
  );
}

export default App;
